const UserKey = 'loginUser'

export function getLoginUser () {
  return JSON.parse(localStorage.getItem(UserKey));
}

export function setLoginUser (user) {
  localStorage.setItem(UserKey, JSON.stringify({
    account: user.account,
    jobNumber: user.jobNumber,
    storeType: user.storeType,
    loginDate: user.loginDate,
    expireDate: user.expireDate,
    token: user.token,
    clientId: user.clientId
  }));
}

export function removeLoginUser () {
  localStorage.removeItem(UserKey);
}

export function isCashier () {
  const loginUser = getLoginUser();
  return loginUser.jobNumber;
}

export function getToken () {
  const loginUser = getLoginUser();
  if (getLoginUser() == null) {
    return null;
  }
  return loginUser.token;
}

export function getLoginDate () {
  const loginUser = getLoginUser();
  if (loginUser && loginUser.loginDate) {
    return new Date(loginUser.loginDate);
  }
  new Date();
}

export function getExpireDate () {
  const loginUser = getLoginUser();
  if (loginUser && loginUser.expireDate) {
    return new Date(loginUser.expireDate);
  }
  return null;
}
